import { useEffect } from "react";
import throttle from "lodash/throttle";

// Ported from: https://medium.com/mtholla/create-a-transitioning-header-using-react-hooks-like-mediums-c70ed211f7c9

type Options = {
    timeoutDelay?: number;
    minimumScroll?: number;
};

export const useHeaderTrigger = (callback: (isVisible: boolean) => void, options?: Options): void => {
    // TODO: to use a better header hide logic, uncomment this code
    //const [, setScrollPosition] = useState(0);
    //let previousScrollTop = 0;

    const handleDocumentScroll = (): void => {
        const { scrollTop: currentScrollTop } = document.body;

        //setScrollPosition((previousPosition) => {
        //    //previousScrollTop = previousPosition;
        //    return currentScrollTop;
        //});

        //const isScrolledDown = previousScrollTop < currentScrollTop;
        //const isMinimumScrolled = currentScrollTop > (options?.minimumScroll ?? 80);

        setTimeout(() => {
            callback(currentScrollTop > 50);
        }, options?.timeoutDelay ?? 400);
    };

    const handleDocumentScrollThrottled = throttle(handleDocumentScroll, 250);

    useEffect(() => {
        document.body.addEventListener("scroll", handleDocumentScrollThrottled);

        return () => document.body.removeEventListener("scroll", handleDocumentScrollThrottled);

        // Should only run once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
